export const FE_ADMIN_SEARCH_REQUEST = "FE_ADMIN_SEARCH_REQUEST";
export const FE_ADMIN_SEARCH_FAILURE = "FE_ADMIN_SEARCH_FAILURE";
export const FE_ADMIN_SEARCH_SUCCESS = "FE_ADMIN_SEARCH_SUCCESS";
